import Vue from 'vue'
import VueI18n from 'vue-i18n';

import localeEN from './en';
import enLocale from 'element-ui/lib/locale/lang/en';

import localePTBR from './pt-br';
import elementLocalePTBR from 'element-ui/lib/locale/lang/pt-br';

import localeES from './es';
import esLocale from 'element-ui/lib/locale/lang/es';

import app from '../app/i18nApp';
import utilsService from '../services/UtilsService'

const messages = {
  en: {
    ...localeEN,
    ...enLocale,
    ...app.en
  },
  pt: {
    ...localePTBR,
    ...elementLocalePTBR,
    ...app.pt
  },
  es: {
    ...localeES,
    ...esLocale,
    ...app.es
  }
};

/*export default {
  ...messages
}*/

Vue.use(VueI18n);

let userLocale = utilsService.localStorageGetItem("USER_LOCALE");

const i18n = new VueI18n({
  locale: userLocale ? userLocale : 'pt',
  messages
});

export default i18n;




// WEBPACK FOOTER //
// ./src/i18n/index.js